module.exports = __webpack_public_path__ + "img/bg-coupon.be9d847b.png";